import React from "react";

interface Props {
  ios?: {
    link: string;
  };
  android?: {
    link: string;
  };
}

const StoreBadges = ({ ios, android }: Props) => {
  const appStoreBadge = require("../images/app-store-badge.svg");
  const playStoreBadge = require("../images/play-store-badge.svg");

  return (
    <div className="flex w-full items-center my-4">
      <div className="flex-1">
        {ios && (
          <a
            className="inline-block mr-8"
            href={ios.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={appStoreBadge}
              style={{ width: "135px", height: "40px" }}
              alt="Apple App Store"
            />
          </a>
        )}
        {android && (
          <a
            className="inline-block"
            href={android.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={playStoreBadge}
              style={{ width: "135px", height: "40px" }}
              alt="Google Play Store"
            />
          </a>
        )}
      </div>
    </div>
  );
};

export default StoreBadges;
